import { select } from "redux-saga/effects";

export function* getCommonApiParams(reducerName, key = "currentUser") {
  let { organization_id, short_url } = yield select((state) => state[reducerName][key]);

  return { organization_id: organization_id.toString(), short_url };
}
